import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { InputFormField } from "../../../formfields/InputFormField";
import { FormButtons } from "../../FormButtons";
import { FormHeader } from "../../FormHeader";
import { LabNotebook, labNoteBooksConstants, labNotebookFieldLabels } from "../../../../ELN/types/LabNotebook";
import { ProjectsVirtualizedSelectForm } from "../../EntityForms/formsVirtualized/ProjectsVirtualizedSelectForm";
import { TextareaFormField } from "../../../formfields/TextareaFormField";
import { LabNotebookFormValues } from "../../../../ELN/LabNotebooks/Forms/LabNotebookForm";
import { useCallback } from "react";
import { useQuickEditSubmit } from "../common/useQuickEditHooks";
import { QuickEditChildrenProps } from "../common/QuickEditWrapper";

export const QuickEditLabNotebookForm = ({ onEdit, onCancel, initialValues }: QuickEditChildrenProps<LabNotebook>) => {
  const { onSubmit } = useQuickEditSubmit<LabNotebook>({
    resource: labNoteBooksConstants.resource,
    onEdit: onEdit,
    onCancel: onCancel,
  });

  const FormSchema = yup.object().shape({
    name: yup.string().required("Notebook name is required").typeError("Notebook name is required"),
  });

  const entityToFormValues = useCallback((entity?: LabNotebook) => {
    return !!entity
      ? ({
          ...entity,
        } as LabNotebookFormValues)
      : {};
  }, []);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<LabNotebookFormValues>({
    defaultValues: entityToFormValues(initialValues),
    resolver: yupResolver(FormSchema),
  });

  const formValuesToEntity = useCallback(
    (entity: LabNotebookFormValues) => entity.id && onSubmit(entity.id, { ...entity } as LabNotebook),
    [onSubmit]
  );

  return (
    <>
      <FormHeader title={`Edit ${labNoteBooksConstants.entitySingular}`} subtitle={initialValues?.name} />

      <InputFormField
        id="name"
        label={labNotebookFieldLabels.name}
        errors={errors}
        register={register}
        autoFocus={true}
        required
        placeholder={`Enter ${labNoteBooksConstants.entitySingular} name...`}
      />

      <ProjectsVirtualizedSelectForm
        id="projects"
        label={labNotebookFieldLabels.projects}
        control={control}
        showControls
        horizontal
        isMulti
        filters={{ currentUserHasAddPermission: true }}
      />

      <TextareaFormField
        id="description"
        label={labNotebookFieldLabels.description}
        errors={errors}
        register={register}
        placeholder="Enter description..."
      />

      <FormButtons
        onClose={onCancel}
        onSubmit={handleSubmit(formValuesToEntity)}
        disabled={isSubmitting}
        errors={errors}
      />
    </>
  );
};
